export const ALL_PRODUCTS = 'ALL_PRODUCTS'
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS'
export const ALL_PRODUCTS_FAILURE = 'ALL_PRODUCTS_FAILURE'

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID'
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS'

export const ADD_PRODUCT = 'ADD_PRODUCT'
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS'
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE'

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE'

export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'
export const REMOVE_PRODUCT_SUCCESS = 'REMOVE_PRODUCT_SUCCESS'
export const REMOVE_PRODUCT_FAILURE = 'REMOVE_PRODUCT_FAILURE'

export const ALL_CATEGORY_SUCCESS= 'ALL_CATEGORY_SUCCESS'

export const SET_AUTH_STATE = 'SET_AUTH_STATE'
export const SET_AUTH_DATA = 'SET_AUTH_DATA'

export const UPDATE_LOCALE = 'UPDATE_LOCALE'